import React, { useState } from "react";
import { useSelector } from "react-redux";
import tokenStorage from "../../../services/tokenStorage";

import { Container, Grid } from "@mui/material";
import WelcomeCard from "../CMS/WelcomeCard";
import JPWidget from "./JPWidget";
import LoginCard from "../../Common/Card/LoginCard";
import BreadcrumbBuilder from "./BreadcrumbBuilder";
import JPAvatar from "./JPAvatar";

import { getApplication } from "../../../reducers";

function Dashboard() {
    const [loginUrl, setLoginUrl] = useState(null);

    const app = useSelector((state) => getApplication(state, "P-JP"));
    if (!!app && !loginUrl) {
        tokenStorage.getSSOToken(app.uuid).then((token) => {
            if (!!token) {
                const redirectRoute = encodeURIComponent(
                    "/portfolio/jobplan/main"
                );
                setLoginUrl(
                    `${app.serviceURL}/sso?access_token=${token}&rd=${redirectRoute}`
                );
            }
        });
    }

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <WelcomeCard appCode="P-JP" />
                </Grid>

                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <JPWidget />
                </Grid>

                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <LoginCard
                        appName="Job Planner"
                        avatar={<JPAvatar />}
                        loginURL={loginUrl}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}

export default Dashboard;
